import { createApp } from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
// import router from './router'
import { createRouter, createWebHistory } from 'vue-router'
import Courses from './components/Courses.vue'
import Quiz from './components/Quiz.vue'
import Home from './components/Home.vue'
import ProfilePage from './components/ProfilePage.vue'
import Profile from './components/Profile.vue'
import Login from './components/Login.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import Feedback from './components/Feedback.vue'
import NotFound from './components/NotFound.vue'
import Pricing from './components/Pricing.vue'
import Markdown from 'vue3-markdown-it';




// const app = createApp(App);




// import Vue from 'vue';
// import VueRouter from 'vue-router';

// Vue.config.productionTip = false;

import 'primeicons/primeicons.css'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: Home, props: true },
        { path: '/quiz/:id', component: Quiz, props: true, name: 'quiz' },
        { path: '/course/:id', component: Courses, props: true, name: 'course' },
        { path: '/course/:id/:subid', component: Courses, props: true, name: 'course1' },
        { path: '/profile/', component: ProfilePage, props: true, name: 'profile' },
        { path: '/pf/', component: Profile, props: true, name: 'pf' },
        { path: '/login/', component: Login, props: true, name: 'login' },
        { path: '/forgotpassword/', component: ForgotPassword, props: true, name: 'forgotpassword' },
        { path: '/feedback/', component: Feedback, props: true, name: 'feedback' },
        { path: '/pricing/', component: Pricing, name: 'pricing' },
        { path: '/:pathMatch(.*)', component: NotFound, name: 'not-found' },

    ],
    scrollBehavior() {
        return { top: 0 }
    }

});






createApp(App).use(router).use(VueLazyload).use(Markdown).mount('#app')

// const routes = [
//     {path: '/', component: App},
//     {path: '/course/:id', component: Course, props: true}
// ];

// const router = new VueRouter (
//     {
//         routes,
//         mode: 'history'
//     }
// );

// new Vue({
//     render: h => h(App),
//     router}
// ).$mount("#app");